import { cn } from '@/lib/utils'

/**
 * Logo da paroquia.
 *
 * `url` nulo cai no brasao padrao servido pela API (/favicon.svg), que e o
 * mesmo usado como icone do site. Assim o cabecalho nunca fica vazio enquanto
 * nenhuma logo foi definida, e nao existe um segundo desenho padrao para
 * manter em acordo.
 */
export function LogoDaParoquia({
  url,
  alt,
  className,
}: {
  url?: string | null
  alt?: string | null
  className?: string
}) {
  return (
    <img
      src={url ?? '/favicon.svg'}
      // Vazio quando decorativa: o nome da paroquia ja esta escrito ao lado, e
      // o leitor de tela nao deve ler a mesma informacao duas vezes.
      alt={url ? (alt ?? '') : ''}
      aria-hidden={!alt}
      className={cn('object-contain', className)}
    />
  )
}
